import { z } from "zod";
export const modelBlockChangeSchema = z.object({
    blockId: z.string().min(1),
    newBody: z.string().min(1).max(40_000),
});
export const modelQuestionPointSchema = z.object({
    sourceUserMessageId: z.string().uuid(),
    answerMessageId: z.string().uuid(),
    question: z.string().min(1).max(1_000),
    answer: z.string().min(1).max(4_000),
    targetBlockId: z.string().min(1),
});
export const modelProposalSchema = z.object({
    summary: z.string().min(1).max(1_000),
    blockChanges: z.array(modelBlockChangeSchema).min(1).max(12),
    questionPoints: z.array(modelQuestionPointSchema).max(8),
});
